import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { isValidIban } from "@rentiohq/shared-frontend/dist/utils/iban.utils";
import {
  join,
  startsWithOneOf,
} from "@rentiohq/shared-frontend/dist/utils/string.utils";
import { ibanMask, ibanPipe } from "@rentiohq/web-shared/dist/utils/iban.utils";
import {
  ERentioFormField,
  IFormikValues,
  // IFormikValues,
  IUiSchema,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { sortBy } from "lodash";
import { EField, IExtraData } from "./schema.addBankAccount.types";

export const uiSchema = (extraData: IExtraData): IUiSchema => {
  return {
    stepTitle: getLocalizedText("task.information.section_header"),
    heading: getLocalizedText("task.information.section_header"),
    fields: [
      {
        fieldKey: EField.IBAN,
        uiComponent: ERentioFormField.MaskedInput,
        title: getLocalizedText("payment_detail.form.iban.label"),
        required: true,
        additionalValidation: [
          // The field is seeded with "BE" and masked, so anything typed after it
          // looks like an IBAN to the mask - "BEnot-an-iban" reached the API,
          // which stored it (RT-654). The same check the json-schema IBAN field
          // runs (`IbanField.validate`), which is why the broker-side add-IBAN
          // form never had this gap.
          {
            name: "validate_iban_format",
            // An empty field is the `required` rule's business, not this one's.
            test: (value: any) => !value || isValidIban(value),
            message: getLocalizedText("system.form.error.invalid_IBAN"),
          },
          {
            name: "validate_sepa_support",
            test: (value: any, formData: IFormikValues) =>
              !(
                extraData.validateSepaSupported &&
                !startsWithOneOf(
                  formData[EField.IBAN],
                  CONFIG.SUPPORTED_SEPA_COUNTRIES,
                )
              ),
            message: getLocalizedText(
              "payment_detail.form.iban.label.error.not_allowed_iban",
              {
                countries: join(
                  sortBy(
                    CONFIG.SUPPORTED_SEPA_COUNTRIES.map(x =>
                      getLocalizedText(`system.country.${x}`.toLowerCase()),
                    ),
                  ),
                ),
              },
            ),
          },
        ],
        componentProps: {
          autoFocus: true,
          iMaskProps: {
            mask: ibanMask,
            pipe: ibanPipe,
            lazy: false,
            unmask: true,
          },
        },
      },
      {
        fieldKey: EField.OwnerName,
        uiComponent: ERentioFormField.TextField,
        title: getLocalizedText("payment_detail.form.card_holder_name.label"),
        required: true,
      },
    ],
  };
};
